module.exports = __webpack_public_path__ + "img/idcard_front.eb36fd45.png";